import { Severity } from "./biometrics-threshold.model";
import { Source } from "./source.model";

export const BiometricUnit = {
	hemoglobinA1c: "%",
	bloodPressure: "mmHg",
	heartRate: "BPM",
	glucose: "mg/dL",
	weight: "lbs",
	waistCircumference: '"',
	heightFeet: "'",
	heightInches: '"',
	cholesterol: "mg/dL",
	triglycerides: "mg/dL",
	kidneyGfr: "mL/min/1.73 m²",
	steps: "steps",
	calciumCac: "",
	bloodOxygenSaturation: "%",
};

export enum BiometricType {
	hemoglobin_a1c = "A1C",
	blood_pressure_diastolic = "BLOOD_PRESSURE_DIASTOLIC",
	blood_pressure_systolic = "BLOOD_PRESSURE_SYSTOLIC",
	heart_rate = "HEART_RATE",
	blood_pressure = "BLOOD_PRESSURE",
	height = "HEIGHT",
	weight = "WEIGHT",
	waist_circumference = "WAIST_CIRCUMFERENCE",
	cholesterol = "CHOLESTEROL",
	cholesterol_hdl = "CHOLESTEROL_HDL",
	cholesterol_ldl = "CHOLESTEROL_LDL",
	cholesterol_total = "CHOLESTEROL_TOTAL",
	triglycerides = "TRIGLYCERIDES",
	kidney_gfr = "KIDNEY_GFR",
	glucose = "GLUCOSE",
	post_meal = "POST-MEAL",
	pre_meal = "PRE-MEAL",
	control = "CONTROL",
	fasting = "FASTING",
	unlabeled = "UNLABELED",
	calcium = "CALCIUM",
	calcium_cac = "CAC",
	steps = "STEPS",
	blood_oxygen_saturation = "BLOOD_OXYGEN_SATURATION",
}

export interface BiometricEntry {
	biometricId: number;
	value: number;
	unit: string;
	subType: string;
	severity?: Severity;
}

export interface Biometric {
	deviceId: number;
	participantId: number;
	isManual: boolean;
	source: Source;
	notes: string | null;
	mealState: "PRE-MEAL" | "POST-MEAL" | "FASTING" | "CONTROL" | "UNLABELED" | null;
	type: BiometricType;
	subtype: "PRE-MEAL" | "POST-MEAL" | "FASTING" | "CONTROL" | "UNLABELED" | null;
	entries: BiometricEntry[];
	estimated: boolean;
	vitalTime: string; // Date
	deleted: boolean;
	createdOn: string; // Date
	updatedOn: string; // Date
	deletedOn: string | null; // Date
}
